module.exports = __webpack_public_path__ + "img/blog12.66cc725b.png";